import { ReactNode } from 'react'
import { ErrorBoundary, ErrorBoundaryProps } from './ErrorBoundary'
import { useLocation } from 'react-router-dom'

interface RouteErrorBoundaryProps extends Omit<ErrorBoundaryProps, 'level' | 'resetKeys'> {
  children: ReactNode
}

/**
 * Specialized ErrorBoundary for route-level errors.
 *
 * Automatically resets when the route changes (using location as resetKey).
 * Shows route-appropriate fallback UI with navigation options.
 */
export function RouteErrorBoundary({ children, ...props }: RouteErrorBoundaryProps) {
  const location = useLocation()

  return (
    <ErrorBoundary
      level="route"
      resetKeys={[location.pathname]}
      showResetButton={true}
      showHomeButton={true}
      {...props}
    >
      {children}
    </ErrorBoundary>
  )
}
